// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__27UIS","obliqueLineWrap":"membershipbadge_obliqueLineWrap__YzkRo","obliqueLine":"membershipbadge_obliqueLine__1UnsD"};